module.exports = __webpack_public_path__ + "img/Apple.e4f17a4e.png";